/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RefundRequestResponse
 */
export interface RefundRequestResponse {
    /**
     * 환불 신청 ID
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'refundRequestId'?: string;
    /**
     * 주문 ID
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'orderId'?: string;
    /**
     * 원래 결제 금액
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'originalAmount'?: string;
    /**
     * 실제 환불 금액
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'refundAmount'?: string;
    /**
     * 환불 신청 상태
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'status'?: RefundRequestResponseStatusEnum;
    /**
     * 환불 유형
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'refundType'?: RefundRequestResponseRefundTypeEnum;
    /**
     * 환불 사유
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'reason'?: string;
    /**
     * AI API 사용 횟수
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'aiUsageCount'?: string;
    /**
     * 구독 사용 일수
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'subscriptionDaysUsed'?: string;
    /**
     * 환불 가능 여부
     * @type {boolean}
     * @memberof RefundRequestResponse
     */
    'canRefund'?: boolean;
    /**
     * 환불 처리 메시지
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'message'?: string;
    /**
     * 환불 신청 일시
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'createdAt'?: string;
    /**
     * 환불 처리 일시
     * @type {string}
     * @memberof RefundRequestResponse
     */
    'processedAt'?: string;
}

export const RefundRequestResponseStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;

export type RefundRequestResponseStatusEnum = typeof RefundRequestResponseStatusEnum[keyof typeof RefundRequestResponseStatusEnum];
export const RefundRequestResponseRefundTypeEnum = {
    Full: 'FULL',
    Partial: 'PARTIAL',
    AiUsageBased: 'AI_USAGE_BASED'
} as const;

export type RefundRequestResponseRefundTypeEnum = typeof RefundRequestResponseRefundTypeEnum[keyof typeof RefundRequestResponseRefundTypeEnum];


